import styled from "styled-components";
import {useCallback, useEffect, useState} from "react";
import {useRouter} from "next/router";

const FooterWrap = styled.div`
	width: 100%;
	padding-bottom: 40px;
	background: #fff;
	div {
		width: 1200px;
		margin: auto;
		article {
			flex-shrink: 0;
			box-sizing: border-box;
		}
	}
	nav {
		border-top: 1px solid #ddd;
		border-bottom: 1px solid #ddd;
		background-color: #f5f5f5;
		box-sizing: border-box;
		a {
			line-height: 1.6;
			font-size: 15px;
			color: #111;
			font-family: "pr-font-medium";
		}
		div {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 60px;
		}
	}
`;

const Fnb = styled.section`
	nav {
		ul {
			display: flex;
			gap: 30px;
		}
	}
`;

const CsWrap = styled.div`
	div {
		display: flex;
		margin: 60px auto;
		article:first-child {
			width: 470px;
			border-right: 1px solid #ddd;
			font-size: 16px;
			color: #555;
			> p {
				line-height: 1;
				letter-spacing: -0.025em;
				font-size: 28px;
				font-family: "pr-font-medium";
				color: #111;
			}
			dl {
				display: flex;
				gap: 20px;
				line-height: 1;
				margin: 30px 0;
				dt {
					font-family: "pr-font-medium";
					color: #111;
				}
			}
			ul li {
				position: relative;
				line-height: 1;
				padding-left: 10px;
				+ li {
					margin-top: 20px;
				}
				&:before {
					position: absolute;
					top: 10px;
					left: 0;
					display: block;
					width: 2px;
					height: 2px;
					background: #999;
					content: "";
				}
				p {
					line-height: 1.6;
				}
			}
		}
		article:nth-child(2) {
			padding: 0 25px 0 60px;
			ul {
				display: flex;
				gap: 40px;
				li {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: flex-start;
					gap: 20px;
					width: 190px;
					> p {
						line-height: 1;
						font-size: 20px;
						letter-spacing: -0.025em;
						em {
							line-height: 1;
							font-size: 26px;
							font-family: "pr-font-medium";
							color: #111;
							letter-spacing: 0;
						}
					}
					> button {
						height: 40px;
						line-height: 1;
						padding: 12px 20px;
						border: 1px solid #555;
						background-color: #fff;
						border-radius: 4px;
						font-size: 14px;
						font-family: "pr-font-medium";
						color: #111;
						white-space: nowrap;
						box-sizing: border-box;
						cursor: pointer;
					}
					&::before {
						display: block;
						width: 30px;
						height: 30px;
						margin-bottom: 5px;
						background-repeat: no-repeat;
						background-position: center;
						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_pkg.png);
						content: "";
					}
					&:nth-child(2):before {
						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_air.png);
					}
					&:last-child:before {
						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_region.png);
					}
				}
			}
		}
	}
`;

const LinkWrap = styled.section`
	nav {
		height: 60px;
		background-color: #fff;
		box-sizing: border-box;
		ul:first-child {
			display: flex;
			gap: 30px;
		}
	}
`;

const Sns = styled.ul`
	display: flex;
	gap: 6px;
`;

const SnsItem = styled.li<{$sns: string}>`
	a {
		display: block;
		width: 34px;
		height: 34px;
		&:before {
			position: absolute;
			display: block;
			width: 34px;
			height: 34px;
			border-radius: 50%;
			background: #fff url(https://cimgcdn.ybtour.co.kr/common/footer/btn_sns.png) no-repeat;
			content: " ";
			background-position: ${props => {
				if (props.$sns === "facebook") {
					return `
                0 0;
            `;
				}
				if (props.$sns === "instagram") {
					return `
				-34px 0;
            `;
				}
				if (props.$sns === "youtube") {
					return `
				-68px 0;
            `;
				}
				if (props.$sns === "kakao") {
					return `
				-102px 0;
            `;
				}
				if (props.$sns === "blog") {
					return `
				-136px 0;
            `;
				}
				if (props.$sns === "post") {
					return `
				-170px 0;
            `;
				}
			}};
		}
		span {
			position: absolute;
			width: 1px;
			height: 1px !important;
			padding: 0;
			margin: -1px;
			border: none;
			clip: rect(0 0 0 0);
			overflow: hidden;
		}
	}
`;

const Policies = styled.ul`
	li {
		&:nth-child(2) > a em {
			color: #4567ad;
			font-family: "pr-font-medium";
		}
	}
`;

const CompanyInfo = styled.section`
	margin: 40px auto;
`;

const Corporation = styled.div`
	display: flex;
	article:first-child {
		position: relative;
		width: 780px;
		border-right: 1px solid #ddd;
		h5 {
			line-height: 1;
			margin: 0 0 30px 0;
			font-size: 15px;
			font-family: "pr-font-bold";
			color: #222;
		}
		img {
			width: 130px;
			height: 10px;
			margin-left: 20px;
			vertical-align: baseline;
		}
		address {
			font-size: 12px;
			line-height: 1.8;
			color: #777;
			+ address {
				margin-top: 10px;
			}
			+ span {
				margin-top: 20px;
			}
		}
		span {
			display: block;
			margin: 0;
			font-size: 12px;
			font-style: normal;
			line-height: 1.8;
			color: #777;
		}
		> a {
			margin-left: 10px;
			font-size: 12px;
			text-decoration: underline;
			color: #555;
		}
		i {
			font-style: normal;
			&:after {
				display: inline-block;
				width: 1px;
				height: 10px;
				margin: 0 6px 0 8px;
				background: #999;
				content: " ";
			}
		}
	}
	article:last-child {
		width: 430px;
		padding-left: 40px;
		> a {
			position: relative;
			line-height: 1;
			margin-right: 12px;
			font-family: "pr-font-medium";
			color: #111;
			font-size: 14px;
			&:after {
				position: absolute;
				top: 50%;
				left: 100%;
				width: 5px;
				height: 5px;
				margin: -3px 0 0 5px;
				border-top: 1px solid #111;
				border-right: 1px solid #111;
				transform: rotate(45deg);
				content: " ";
			}
		}
		span {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			gap: 10px;
			width: 390px;
			margin: 20px 0 25px;
			font-size: 13px;
		}
		dl {
			display: flex;
			gap: 10px;
			line-height: 1;
			dt {
				min-width: 98px;
				color: #555;
			}
			dd {
				min-width: 80px;
				color: #111;
				font-family: "pr-font-medium";
			}
			&:nth-child(2) {
				dt {
					min-width: 78px;
				}
			}
		}
		span + ul {
			display: contents;
			font-size: 12px;
			color: #777;
			li {
				display: flex;
				width: 100%;
				margin: 0;
				line-height: 1.8;
				em {
					width: 60px;
				}
				a {
					width: 310px;
					text-decoration: underline;
				}
			}
		}
	}
`;

const AwardList = styled.ul`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 60px;
`;

const AwardListItem = styled.li<{$award: string}>`
	position: relative;
	height: 60px;
	&:nth-child(1) button,
	&:nth-child(2) button {
		width: 165px;
		&::before {
			width: 165px;
		}
	}
	button {
		position: relative;
		width: 162px;
		height: 60px;
		padding: 0;
		border: 0;
		background-color: transparent;
		text-indent: 0;
		cursor: pointer;
		overflow: visible;
		span {
			position: absolute;
			width: 1px;
			height: 1px !important;
			padding: 0;
			margin: -1px;
			border: none;
			clip: rect(0 0 0 0);
			overflow: hidden;
		}
		&:before {
			display: block;
			height: 60px;
			background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/btn_award_202503.png);
			background-position: 0 0;
			background-repeat: no-repeat;
			content: "";
			background-position: ${props => {
				if (props.$award === "ccm") {
					return `0 0`;
				}
				if (props.$award === "ftc") {
					return `-175px 0`;
				}
				if (props.$award === "ccm2023") {
					return `-350px 0`;
				}
				if (props.$award === "knqa") {
					return `-522px 0`;
				}
				if (props.$award === "scsi") {
					return `-694px 0`;
				}
				if (props.$award === "icsi") {
					return `-866px 0`;
				}
				if (props.$award === "isms") {
					return `-1038px 0`;
				}
			}};
		}
	}
`;

const CopyrightWrap = styled.div`
	ul {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		height: auto;
		margin: 20px 0 30px;
		li {
			position: relative;
			padding-left: 7px;
			font-size: 12px;
			color: #777;
			&:before {
				position: absolute;
				top: 6px;
				left: 0;
				display: block;
				width: 2px;
				height: 2px;
				background: #999;
				content: " ";
			}
			+ li {
				margin-top: 10px;
			}
		}
	}
	+ p {
		line-height: 1.8;
		font-size: 12px;
		color: #777;
	}
`;

const FloatingBlock = styled.div`
	position: fixed;
	right: 20px;
	bottom: 40px;
	z-index: 100;
	width: 60px;
	height: 60px;

	button > span {
		font-size: 0;
		color: transparent;
	}
`;

const TalkWrap = styled.div<{$show?: boolean}>`
	position: fixed;
	right: 20px;
	bottom: 40px;
	z-index: 100;
	transition: bottom 0.4s;
	${props =>
		props.$show &&
		`
		bottom: 110px;
	`}
`;

const TalkBtn = styled.button`
	position: relative;
	z-index: 105;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 4px;
	width: 60px;
	height: 60px;
	border-radius: 50%;
	background-color: #ffce3c;
	font-size: 14px;
	color: var(--gray-color);
	cursor: pointer;

	&:before {
		display: block;
		width: 20px;
		height: 22px;
		background-image: url(https://cimgcdn.ybtour.co.kr/common/ico/ico_chatbot.png);
		background-repeat: no-repeat;
		background-size: contain;
		content: "";
	}
	&:after {
		display: inline-block;
		content: "상담";
		font-family: "pr-font-bold";
		font-size: 14px;
		letter-spacing: -0.025em;
		color: #111;
	}
	+ div {
		position: absolute;
		top: 0;
		right: 30px;
		z-index: 100;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 0;
		height: 60px;
		padding: 0;
		border-radius: 100px 0 0 100px;
		background: #555;
		overflow: hidden;
		box-sizing: border-box;
		opacity: 0;
		transition: all 0.4s;

		> span {
			color: #fff;
			font-size: 15px;
			letter-spacing: -0.025em;
			white-space: nowrap;
		}
	}
	&:hover + div {
		width: 245px;
		padding: 0 45px 0 30px;
		opacity: 1;
	}
`;

const TopButton = styled.button<{$show: boolean}>`
	position: relative;
	width: 60px;
	height: 60px;
	margin-bottom: -1px;
	border: 1px solid var(--line-color);
	border-radius: 50%;
	background-color: #fff;
	font-size: 14px;
	color: var(--gray-color);
	opacity: 0;
	animation: fadeout 0.4s;
	cursor: pointer;
	:hover,
	:active {
		background-color: #111;
		:before {
			border-color: #fff;
		}
		:after {
			background-color: #fff;
		}
	}
	:before {
		position: absolute;
		top: 20px;
		left: 50%;
		display: block;
		width: 12px;
		height: 12px;
		margin: 0 0 0 -6px;
		border-top: 2px solid #111;
		border-right: 2px solid #111;
		transform: rotate(-45deg);
		content: "";
	}
	:after {
		position: absolute;
		display: block;
		top: 20px;
		left: 50%;
		width: 2px;
		height: 20px;
		background-color: #111;
		content: "";
	}

	${props =>
		props.$show &&
		`
			opacity: 1;
			animation: fadein 0.4s;
	`}

	@keyframes fadein {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	@keyframes fadeout {
		0% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
`;

const LogoList = styled.ul`
	position: absolute;
	top: 0;
	right: 40px;
	display: flex;
	gap: 15px;
	li {
		&:nth-child(2) {
			a {
				&::before {
					width: 60px;
					background-position: -65px 0;
				}
			}
		}
		a {
			display: block;
			width: 100%;
			height: 100%;
			&::before {
				display: block;
				width: 65px;
				height: 56px;
				background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/logo_franchise.png);
				background-size: auto 56px;
				background-position: 0 0;
				background-repeat: no-repeat;
				content: "";
			}
		}
		span {
			position: absolute;
			width: 1px;
			height: 1px !important;
			padding: 0;
			margin: -1px;
			border: none;
			clip: rect(0 0 0 0);
			overflow: hidden;
		}
	}
`;

const Footer = () => {
	const router = useRouter();
	const [topShow, setTopShow] = useState(false);
	const [lastScrollTop, setLastScrollTop] = useState(0);
	const handleScroll = () => {
		const currentScrollTop = window.scrollY || document.documentElement.scrollTop;

		if (currentScrollTop > lastScrollTop) {
			setTopShow(false);
		} else {
			setTopShow(true);
		}
		setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
	};

	const onClickAward = (value: string) => {
		window.open(
			`https://www.ybtour.co.kr/assets/main/desktop/webcontent/awards_popup.html${value ? `#award=${value}` : ""}`,
			"popupWindow",
			"width=600,height=720,left=200,top=200",
		);
	};

	const top = useCallback(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [lastScrollTop, router]);

	return (
		<>
			<FooterWrap className="footer">
				<Fnb>
					<nav>
						<div>
							<ul>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/main.yb">고객센터</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/noticeList.yb">공지사항</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/faqList.yb">자주하는질문</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/qnaGuide.yb">1:1문의</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/estimateWrite.yb">견적문의</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/eplg/episodeList.yb">여행후기</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/praiseList.yb">칭찬합시다</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/freeInstallmentPopup.yb" target="_blank" rel="noreferrer">
										무이자할부
									</a>
								</li>
								<li>
									<a
										href="https://pkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd="
										target="_self"
									>
										현금영수증
									</a>
								</li>
							</ul>
						</div>
					</nav>
				</Fnb>
				<CsWrap>
					<div>
						<article>
							<p>노랑풍선 고객센터</p>
							<dl>
								<dt>상담시간</dt>
								<dd>평일 오전 9시 ~ 오후 6시 (토,일요일 및 공휴일 휴무)</dd>
							</dl>
							<ul>
								<li>
									<p>
										해외항공권 변경, 투어&티켓, 렌터카 취소/변경/환불:
										<br />
										평일 오후 5시까지
									</p>
								</li>
								<li>
									<p>호텔 취소/변경/환불: 평일 오후 4시까지</p>
								</li>
							</ul>
						</article>
						<article>
							<ul>
								<li>
									<p>패키지여행 상담</p>
									<p>
										<em>1544-2288</em>
									</p>
									<button
										onClick={() => {
											window.open("https://pkg.ybtour.co.kr/cs/arsGuide.yb");
										}}
									>
										지역별 직통 상담번호 안내
									</button>
								</li>
								<li>
									<p>자유여행 상담</p>
									<p>
										<em>1644-3399</em>
									</p>
								</li>
								<li>
									<p>부산/지방출발 상담</p>
									<p>
										<em>051-713-0710</em>
									</p>
								</li>
							</ul>
						</article>
					</div>
				</CsWrap>
				<LinkWrap>
					<nav>
						<div>
							<Policies>
								<li>
									<a href="http://company.ybtour.co.kr/" target="_blank" rel="noreferrer">
										회사소개
									</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/common/privacy.yb">
										<em>개인정보처리방침</em>
									</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/common/internetAgree.yb">이용약관</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/common/travelAgree.yb">여행약관</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/common/travelerInsuInfo.yb">여행자보험</a>
								</li>
								<li>
									<a href="http://company.ybtour.co.kr/agent/about" target="_blank" rel="noreferrer">
										대리점안내
									</a>
								</li>
								<li>
									<a href="https://pkg.ybtour.co.kr/cs/directionGuide.yb">오시는 길</a>
								</li>
							</Policies>
							<Sns>
								<SnsItem $sns="facebook">
									<a href="https://www.facebook.com/yellowballoonofficial/" target="_blank" rel="noreferrer">
										<span>노랑풍선 페이스북 바로가기</span>
									</a>
								</SnsItem>
								<SnsItem $sns="instagram">
									<a href="https://www.instagram.com/yellowballoon_official/" target="_blank" rel="noreferrer">
										<span>노랑풍선 인스타 바로가기</span>
									</a>
								</SnsItem>
								<SnsItem $sns="youtube">
									<a href="https://www.youtube.com/user/ybtour2013" target="_blank" rel="noreferrer">
										<span>노랑풍선 유튜브 바로가기</span>
									</a>
								</SnsItem>
								<SnsItem $sns="kakao">
									<a href="https://pf.kakao.com/_hhAxbd" target="_blank" rel="noreferrer">
										<span>노랑풍선 플러스친구 바로가기</span>
									</a>
								</SnsItem>
								<SnsItem $sns="blog">
									<a href="https://blog.naver.com/yb_tour" target="_blank" rel="noreferrer">
										<span>노랑풍선 네이버블로그 바로가기</span>
									</a>
								</SnsItem>
							</Sns>
						</div>
					</nav>
				</LinkWrap>
				<CompanyInfo>
					<Corporation>
						<article>
							<h5>
								(주)노랑풍선
								<img src="https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png" alt="코스닥상장법인" />
							</h5>
							<address>
								대표이사 김진국<i></i>서울특별시 중구 수표로31, 노랑풍선빌딩
								<br />
								사업자등록번호 104-81-64440 <i></i>관광사업자등록증번호 제2006-000003호<i></i>통신판매업신고번호
								제2008-서울중구-0278
								<a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440" target="_blank" rel="noreferrer">
									사업자 정보확인
								</a>
							</address>
							<address>
								[부산지사] 부산광역시 부산진구 중앙대로668, 9층 912호 (부전동, 에이원프라자)
								<br />
								사업자등록번호 870-85-01900
							</address>
							<span>
								영업배상책임보험가입 총 20억원 · 한국관광협회중앙회 여행공제회 공제영업보증가입 10억원 ·
								공제기획여행보증가입 5억원
							</span>
							<LogoList>
								<li>
									<a href="http://tourinfo.or.kr/standard/partners.asp" target="_blank" rel="noreferrer">
										<span>국외여행상품 정보제공 표준안 참여 여행사</span>
									</a>
								</li>
								<li>
									<a
										href="https://pkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=
"
										target="_self"
										rel="noreferrer"
									>
										<span>현금영수증 의무발행 가맹점</span>
									</a>
								</li>
							</LogoList>
						</article>
						<article>
							<a href="https://pkg.ybtour.co.kr/cs/main.yb">고객센터</a>
							<span>
								<dl>
									<dt>패키지여행 상담</dt>
									<dd>1544-2288</dd>
								</dl>
								<dl>
									<dt>자유여행 상담</dt>
									<dd>1644-3399</dd>
								</dl>
								<dl>
									<dt>부산/지방출발 상담</dt>
									<dd>051-713-0710</dd>
								</dl>
							</span>
							<ul>
								<li>
									<em>대표메일</em>
									<a href="mailto:master@ybtour.com">master@ybtour.com</a>
								</li>
								<li>
									<em>판매제휴</em>
									<a href="mailto:salespartner@ybtour.com">salespartner@ybtour.com</a>
								</li>
								<li>
									<em>마케팅제휴</em>
									<a href="mailto:marketing@ybtour.com">marketing@ybtour.com</a>
								</li>
								<li>
									<em>대리점문의</em>
									<a href="mailto:sales.agent@ybtour.co.kr">sales.agent@ybtour.co.kr</a>
								</li>
							</ul>
						</article>
					</Corporation>
				</CompanyInfo>
				<section>
					<div>
						<AwardList>
							<AwardListItem $award="ccm">
								<button onClick={() => onClickAward("award1")}>
									<span>소비자중심경영 공정거래위원회 한국소비자원</span>
								</button>
							</AwardListItem>
							<AwardListItem $award="ftc">
								<button onClick={() => onClickAward("award2")}>
									<span>소비자중심경영 국무총리 표창</span>
								</button>
							</AwardListItem>
							<AwardListItem $award="ccm2023">
								<button onClick={() => onClickAward("award3")}>
									<span>소비자중심경영 공정거래위원장 표창</span>
								</button>
							</AwardListItem>
							<AwardListItem $award="knqa">
								<button onClick={() => onClickAward("award4")}>
									<span>제45회 국가품질경영대회서비스품질우수상</span>
								</button>
							</AwardListItem>
							<AwardListItem $award="scsi">
								<button onClick={() => onClickAward("award5")}>
									<span>SCSI 대한민국 소셜미디어대상 1위</span>
								</button>
							</AwardListItem>
							<AwardListItem $award="icsi">
								<button onClick={() => onClickAward("award5")}>
									<span>ICSI 대한민국 인터넷소통대상 기업부문 대상 1위</span>
								</button>
							</AwardListItem>
							<AwardListItem $award="isms">
								<button onClick={() => onClickAward("award6")}>
									<span>정보보호 관리체계 인증</span>
								</button>
							</AwardListItem>
						</AwardList>
						<CopyrightWrap>
							<ul>
								<li>
									노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다.
									따라서 해당 상품의 상품·거래정보 및 거래 등에 대하여 책임을 지지 않습니다.
								</li>
								<li>
									항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된
									가격이며, 유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다.
								</li>
								<li>
									노랑풍선의 &apos;예금주&apos; 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에
									관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에
									노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다.
								</li>
							</ul>
						</CopyrightWrap>
						<p>© Yellow Balloon tour. All Rights Reserved.</p>
					</div>
				</section>
			</FooterWrap>
			<FloatingBlock>
				{/* <TalkWrap $show={topShow}>
					<TalkBtn>
						<span>해피톡 상담</span>
					</TalkBtn>
					<div>
						<span>허니문 채팅상담 서비스입니다.</span>
					</div>
				</TalkWrap> */}
				<TopButton $show={topShow} onClick={top}>
					<span>최상단 이동</span>
				</TopButton>
			</FloatingBlock>
		</>
	);
};
export default Footer;

export {
	FooterWrap,
	Fnb,
	CsWrap,
	LinkWrap,
	Sns,
	SnsItem,
	Policies,
	CompanyInfo,
	Corporation,
	AwardList,
	AwardListItem,
	CopyrightWrap,
	LogoList,
	TopButton,
	FloatingBlock,
	TalkWrap,
	TalkBtn,
};
